module.exports = __webpack_public_path__ + "img/dep_coffeeandtea@3x.0b382413.png";